import { Link } from "react-router-dom";
import { Briefcase, ClipboardList, Rocket, Zap, ArrowRight, ArrowLeft } from "lucide-react";
import { useLang } from "../context/LanguageContext";
import { WHATSAPP_URL } from "../lib/i18n";

const ICONS = [Briefcase, ClipboardList, Rocket, Zap];

export function BusinessHub() {
  const { t, isRTL } = useLang();
  const Arrow = isRTL ? ArrowLeft : ArrowRight;

  return (
    <section className="py-20 bg-gradient-to-br from-cyan-50 via-white to-red-50/30 relative overflow-hidden" data-testid="business-hub">
      <div className="absolute inset-0 opacity-[0.04] pointer-events-none" style={{
        backgroundImage: 'radial-gradient(circle at 20% 20%, #0891b2 0%, transparent 45%), radial-gradient(circle at 80% 80%, #ef4444 0%, transparent 45%)'
      }} />
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 relative">
        <div className="max-w-2xl mb-12">
          <div className="inline-block text-[10px] tracking-[0.3em] text-[#ef4444] font-semibold mb-3 uppercase">
            {t.businessHub.eyebrow}
          </div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl mb-4 leading-tight text-[#0891b2]">
            {t.businessHub.title}
          </h2>
          <p className="text-slate-600 leading-relaxed">{t.businessHub.subtitle}</p>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4">
          {t.businessHub.items.map((it, i) => {
            const Icon = ICONS[i] || Briefcase;
            const linkTo = it.link || "/quote";
            const isExternal = linkTo.startsWith("http");
            const Wrapper = isExternal ? "a" : Link;
            const wrapperProps = isExternal
              ? { href: linkTo, target: "_blank", rel: "noreferrer" }
              : { to: linkTo };
            return (
              <Wrapper
                key={i}
                {...wrapperProps}
                data-testid={`hub-card-${i}`}
                className="group relative bg-white hover:bg-white border border-slate-200 hover:border-[#ef4444] rounded-xl p-6 transition-all duration-300 hover:shadow-lg"
              >
                <div className="w-11 h-11 bg-red-50 group-hover:bg-[#ef4444] rounded-lg flex items-center justify-center mb-5 transition-colors">
                  <Icon className="w-5 h-5 text-[#ef4444] group-hover:text-white transition-colors" />
                </div>
                <h3 className="font-display text-lg mb-2 leading-snug text-[#0891b2]">{it.title}</h3>
                <p className="text-slate-600 text-sm leading-relaxed mb-5 min-h-[42px]">{it.text}</p>
                <div className="inline-flex items-center gap-2 text-[#ef4444] text-xs font-semibold uppercase tracking-widest">
                  {it.cta}
                  <Arrow className="w-3.5 h-3.5 group-hover:translate-x-1 rtl:group-hover:-translate-x-1 transition-transform" />
                </div>
              </Wrapper>
            );
          })}
        </div>
      </div>
    </section>
  );
}
